import React from 'react';

const AppPersonal = ({ err, values, handleChange, handleDebtFileChange, prevStep, nextStep, focusedTitleRef, anyUploading, minBirthDate, maxBirthDate }) => {
    const {
        salutation, forename, lastname, address, zip, city, phone, email,
        dateOfBirth, occupation, monthlyIncome, gwgTenant, debtInformation,
        debtUploading, debtUploadError,
        employerCompany, employerPerson, employerPhone, employerOccupation,
        landlordName, landlordPhone,
    } = values;
    const e = err || {};

    return (
        <div>
            <h2 ref={focusedTitleRef} tabIndex={-1}>Mietinteressent:in</h2>

            <fieldset className="mb-4">
                <legend className="form-label">Anrede</legend>
                <div className="d-flex flex-column flex-md-row gap-2 gap-md-3">
                    {[['ms', 'Frau'], ['mr', 'Herr'], ['neutral', 'Neutrale Anrede']].map(([val, label]) => (
                        <div className="form-check" key={val}>
                            <input className="form-check-input" type="radio" id={`sal_${val}`} name="salutation" value={val} checked={salutation === val} onChange={handleChange('salutation')} />
                            <label className="form-check-label" htmlFor={`sal_${val}`}>{label}</label>
                        </div>
                    ))}
                </div>
            </fieldset>

            <div className="row mb-3">
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="forename">Vorname <span className="required-marker">*</span></label>
                    <input id="forename" name="forename" autoComplete="given-name" type="text" className={`form-control${e.forename ? ' is-invalid' : ''}`} value={forename} onChange={handleChange('forename')} />
                    {e.forename && <div className="invalid-feedback">{e.forename}</div>}
                </div>
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="lastname">Nachname <span className="required-marker">*</span></label>
                    <input id="lastname" name="lastname" autoComplete="family-name" type="text" className={`form-control${e.lastname ? ' is-invalid' : ''}`} value={lastname} onChange={handleChange('lastname')} />
                    {e.lastname && <div className="invalid-feedback">{e.lastname}</div>}
                </div>
            </div>

            <div className="mb-3">
                <label className="form-label" htmlFor="address">Strasse und Hausnummer <span className="required-marker">*</span></label>
                <input id="address" name="address" autoComplete="street-address" type="text" className={`form-control${e.address ? ' is-invalid' : ''}`} value={address} onChange={handleChange('address')} />
                {e.address && <div className="invalid-feedback">{e.address}</div>}
            </div>

            <div className="row mb-3">
                <div className="col-12 col-md-4">
                    <label className="form-label" htmlFor="zip">PLZ <span className="required-marker">*</span></label>
                    <input id="zip" name="zip" autoComplete="postal-code" inputMode="numeric" type="text" className={`form-control${e.zip ? ' is-invalid' : ''}`} value={zip} onChange={handleChange('zip')} />
                    {e.zip && <div className="invalid-feedback">{e.zip}</div>}
                </div>
                <div className="col-12 col-md-8">
                    <label className="form-label" htmlFor="city">Ort</label>
                    <input id="city" name="city" autoComplete="address-level2" type="text" className="form-control" value={city} onChange={handleChange('city')} />
                </div>
            </div>

            <div className="row mb-3">
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="phone">Telefon <span className="required-marker">*</span></label>
                    <input id="phone" name="phone" autoComplete="tel" type="tel" className={`form-control${e.phone ? ' is-invalid' : ''}`} value={phone} onChange={handleChange('phone')} />
                    {e.phone && <div className="invalid-feedback">{e.phone}</div>}
                </div>
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="email">E-Mail <span className="required-marker">*</span></label>
                    <input id="email" name="email" autoComplete="email" type="email" className={`form-control${e.email ? ' is-invalid' : ''}`} value={email} onChange={handleChange('email')} />
                    {e.email && <div className="invalid-feedback">{e.email}</div>}
                </div>
            </div>

            <div className="row mb-3">
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="dateOfBirth">Geburtsdatum <span className="required-marker">*</span></label>
                    <input id="dateOfBirth" name="dateOfBirth" autoComplete="bday" type="date" className={`form-control${e.dateOfBirth ? ' is-invalid' : ''}`} value={dateOfBirth} min={minBirthDate} max={maxBirthDate} onChange={handleChange('dateOfBirth')} />
                    {e.dateOfBirth && <div className="invalid-feedback">{e.dateOfBirth}</div>}
                </div>
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="occupation">Beruf</label>
                    <input id="occupation" name="occupation" type="text" className="form-control" value={occupation} onChange={handleChange('occupation')} />
                </div>
            </div>

            <div className="row mb-4">
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="monthlyIncome">Monatliches Bruttoeinkommen <span className="required-marker">*</span></label>
                    <div className="input-group">
                        <span className="input-group-text">CHF</span>
                        <input id="monthlyIncome" name="monthlyIncome" type="number" className={`form-control${e.monthlyIncome ? ' is-invalid' : ''}`} min={0} value={monthlyIncome} onChange={handleChange('monthlyIncome')} />
                        {e.monthlyIncome && <div className="invalid-feedback">{e.monthlyIncome}</div>}
                    </div>
                </div>
            </div>

            <fieldset className="mb-4">
                <legend className="form-label">Wohnen Sie aktuell bei der GWG? <span className="required-marker">*</span></legend>
                <div className="form-check">
                    <input className={`form-check-input${e.gwgTenant ? ' is-invalid' : ''}`} type="radio" id="gwgYes" name="gwgTenant" value="yes" checked={gwgTenant === 'yes'} onChange={handleChange('gwgTenant')} />
                    <label className="form-check-label" htmlFor="gwgYes">Ja</label>
                </div>
                <div className="form-check">
                    <input className={`form-check-input${e.gwgTenant ? ' is-invalid' : ''}`} type="radio" id="gwgNo" name="gwgTenant" value="no" checked={gwgTenant === 'no'} onChange={handleChange('gwgTenant')} />
                    <label className="form-check-label" htmlFor="gwgNo">Nein</label>
                </div>
                {e.gwgTenant && <div className="invalid-feedback d-block">{e.gwgTenant}</div>}
            </fieldset>

            {gwgTenant === 'no' && (
                <div className="mb-4">
                    <label className="form-label" htmlFor="debtInformation">Betreibungsauskunft (nicht älter als 3 Monate) <span className="required-marker">*</span></label>
                    <input
                        id="debtInformation"
                        name="debtInformation"
                        type="file"
                        className={`form-control${e.debtInformation ? ' is-invalid' : ''}`}
                        accept=".pdf,.jpg,.jpeg,.png,.bmp"
                        disabled={debtUploading}
                        onChange={(ev) => handleDebtFileChange(ev.target.files[0] || null)}
                    />
                    {debtUploading && (
                        <small className="text-muted mt-1 d-block">
                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                            Wird hochgeladen…
                        </small>
                    )}
                    {!debtUploading && debtInformation && <small className="text-muted text-break mt-1 d-block">{debtInformation.name}</small>}
                    {debtUploadError && <div className="invalid-feedback d-block">{debtUploadError}</div>}
                    {e.debtInformation && <div className="invalid-feedback d-block">{e.debtInformation}</div>}
                </div>
            )}

            <h3 className="mt-4">Referenz/Kontakt Arbeitgeber:in</h3>
            <div className="row mb-3">
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="employerCompany">Firma</label>
                    <input id="employerCompany" name="employerCompany" autoComplete="organization" type="text" className="form-control" value={employerCompany} onChange={handleChange('employerCompany')} />
                </div>
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="employerPerson">Referenzperson</label>
                    <input id="employerPerson" name="employerPerson" autoComplete="off" type="text" className="form-control" value={employerPerson} onChange={handleChange('employerPerson')} />
                </div>
            </div>
            <div className="row mb-4">
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="employerPhone">Telefon</label>
                    <input id="employerPhone" name="employerPhone" autoComplete="off" type="tel" className="form-control" value={employerPhone} onChange={handleChange('employerPhone')} />
                </div>
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="employerOccupation">Beruf</label>
                    <input id="employerOccupation" name="employerOccupation" autoComplete="off" type="text" className="form-control" value={employerOccupation} onChange={handleChange('employerOccupation')} />
                </div>
            </div>

            <h3 className="mt-4">Referenz/Kontakt jetzige:r Vermieter:in</h3>
            <div className="row mb-4">
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="landlordName">Firma/Name</label>
                    <input id="landlordName" name="landlordName" autoComplete="off" type="text" className="form-control" value={landlordName} onChange={handleChange('landlordName')} />
                </div>
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="landlordPhone">Telefon</label>
                    <input id="landlordPhone" name="landlordPhone" autoComplete="off" type="tel" className="form-control" value={landlordPhone} onChange={handleChange('landlordPhone')} />
                </div>
            </div>

            <div className="d-flex justify-content-between flex-row-reverse mt-5">
                <button className="btn btn-secondary" onClick={nextStep} disabled={anyUploading}>Weiter</button>
                <button className="btn btn-secondary btn-back" onClick={prevStep}>Zurück</button>
            </div>
        </div>
    );
};

export default AppPersonal;
